import { render, staticRenderFns } from "./HomeProjects.vue?vue&type=template&id=0320f4e8&"
import script from "./HomeProjects.vue?vue&type=script&lang=js&"
export * from "./HomeProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports